import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderToString } from 'react-dom/server';

import { APIHandler, SharingPopup, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const settings = {};
let buttonCompleted = '';

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      if (userObj && userObj) {
        ({ email } = userObj);
      }
      APIHandler.trackEvent(appId, email, 'videos', type, value, title).then(() => { });
    });
  });
};

const hasPlugin = (name) => {
  let has = false;
  const { plugins } = window.navigator;
  Object.keys(plugins).forEach((i) => {
    if (plugins[i].name.toLowerCase().includes(name.toLowerCase())) {
      has = true;
    }
  });
  return has;
};

const setType = (url, target, icon, fancybox, type) => {
  settings.url = url;
  settings.target = target;
  settings.icon = icon;
  settings.fancybox = fancybox;
  settings.type = type;

  const newIcon = url.includes('spotify') ? 'fab fa-spotify' : icon;

  return (
    <ButtonElement
      url={settings.url}
      fancybox={settings.fancybox}
      target={settings.target}
      icon={newIcon}
      type={settings.type}
    />
  );
};

const ButtonElement = (props) => {
  const {
    fancybox, icon, target, type, url,
  } = props;

  console.log(icon, props, icon.includes('pdf'));
  if (icon === 'fas fa-image') {
    return (
      <a
        id={`${type}-${url}`}
        target={target}
        href={url}
        data-fancybox={type}
        data-type={type}
        data-trigger={fancybox}
        onClick={buttonCompleted}
        data-options={JSON.stringify({
          buttons: ['thumbs', 'close'],
          // share: {
          //   tpl: renderToString(<SharingPopup url={url} />),
          // },
        })}
      >
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  if (icon === 'fa fa-image') {
    return (
      <a
        id={`${type}-${url}`}
        target={target}
        href={url}
        data-fancybox={type}
        data-type={type}
        data-trigger={fancybox}
        onClick={buttonCompleted}
        data-options={JSON.stringify({
          buttons: ['thumbs', 'close'],
          // share: {
          //   tpl: renderToString(<SharingPopup url={url} />),
          // },
        })}
      >
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  if (icon === 'fas fa-link') {
    return (
      <a
        id={`${type}-${url}`}
        target="_blank"
        href={url}
        onClick={buttonCompleted}
        rel="noreferrer"
      >
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  return (
    <a
      id={`${type}-${url}`}
      target={target}
      href={url}
      data-fancybox={url}
      data-type={type}
      data-trigger={fancybox}
      onClick={buttonCompleted}
      data-options={JSON.stringify({
        buttons: ['thumbs', icon.includes('pdf') ? 'share' : '', 'close'],
        share: {
          tpl: renderToString(<SharingPopup url={url} />),
        },
      })}
    >
      <button className="linkButton">
        <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
      </button>
    </a>
  );
};

const setButtonType = (link, type, appId) => {
  let newLink = '';
  const typeWithoutIndex = type.replace(/[0-9]/g, '');

  switch (typeWithoutIndex) {
    case 'weblink':
      return setType(link, '_blank', 'fa fa-link', null, null);

    case 'slideshow':
      return setType('', '', 'fa fa-image', 'slideshow', null);

    case 'map':
      return setType(link, '', 'fa fa-map', 'single_media_map', null);

    case 'salestip':
      return setType(
        '',
        '',
        'fa fa-hand-point-right',
        'single_media_salestip',
        type,
      );

    case 'video':
      newLink = link.substring(0, link.indexOf('.'));
      return setType(
        `https://front.travpromobile.com/${appId}/${newLink}.mp4`,
        '_blank',
        'fa fa-video',
        'iframe',
      );

    case 'audio':
      newLink = link.substring(0, link.indexOf('.'));
      return setType(
        `https://front.travpromobile.com/${appId}/${newLink}.mp4`,
        '_blank',
        'fa fa-volume-up',
        'iframe',
      );

    case 'youtube':
      return setType(
        `https://youtube.com/watch?v=${link}`,
        '',
        'fab fa-youtube',
        'single_media_youtube',
        null,
      );

    case 'pdf':
      return setType(
        `https://stack.travpromobile.com/viewer.php?file=${link}`,
        '_blank',
        'fas fa-file-pdf',
        'single_media_pdf',
        'iframe',
      );

    case 'infographic':
      return setType(link, '', 'fa fa-info', 'single_media', null);

    case 'vimeo':
      return setType(
        `https://vimeo.com/${link}`,
        '_blank',
        'fab fa-vimeo',
        'single_media_pdf',
        null,
      );

    default:
  }
  return false;
};

const setSlideShow = (links, data) => {
  const images = [];
  links.forEach((link) => {
    const key = link;
    images.push(<a
      key={key}
      href={APIHandler.getDownloadURL(link)}
      data-fancybox={data}
      data-options={JSON.stringify({
        buttons: ['thumbs', 'close'],
        // share: {
        //   tpl: renderToString(<SharingPopup url={link} />),
        // },
      })}
    >
      <img src={link} alt="" />
    </a>);
  });
  return images;
};

export default class LinkButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      isComplete: false,
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then(appId => this.setState({ appId }));
  }

  render() {
    const {
      completed, link, mandatory, type,
    } = this.props;
    const { appId, isComplete } = this.state;
    buttonCompleted = () => {
      if (type === 'video') {
        trackShare('videos', link, link);
      }
      if (!isComplete && mandatory) {
        this.setState({ isComplete: true });
        completed();
      }
    };

    return (
      <div className="linkButton__container">
        {setButtonType(link, type, appId)}
        {settings.fancybox === 'slideshow' && (
          <div className="hidden_images">
            {setSlideShow(link.split(','), settings.fancybox)}
          </div>
        )}
        {settings.fancybox !== null &&
          settings.fancybox.includes('single_media') && (
            <div className="hidden_single_media">
              <div
                id={settings.url}
                href={settings.url}
                data-fancybox={settings.fancybox}
                data-options={JSON.stringify({
                  buttons: ['close'],
                  // share: {
                  //   tpl: renderToString(<SharingPopup url={link} />),
                  // },
                })}
              />
            </div>
          )}
      </div>
    );
  }
}

ButtonElement.propTypes = {
  fancybox: PropTypes.string,
  icon: PropTypes.string,
  target: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
};

ButtonElement.defaultProps = {
  fancybox: '',
  icon: 'fa fa-question',
  target: '_blank',
  type: '',
  url: '',
};

LinkButton.propTypes = {
  completed: PropTypes.func.isRequired,
  link: PropTypes.string,
  mandatory: PropTypes.bool,
  type: PropTypes.string,
};

LinkButton.defaultProps = {
  link: '#',
  mandatory: true,
  type: '',
};
